module.exports = __webpack_public_path__ + "img/plus-white.d733ae58.svg";